import { render } from "./MobileFooter.vue?vue&type=template&id=9f271702&scoped=true"
import script from "./MobileFooter.vue?vue&type=script&lang=js"
export * from "./MobileFooter.vue?vue&type=script&lang=js"

import "./MobileFooter.vue?vue&type=style&index=0&id=9f271702&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f271702"]])

export default __exports__